import { WellGeothermalFieldsEdit } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import LookupField from '../../wells/lookup-field'
import { FormField, Heading, TextInput } from '@msaf/core-react'

interface WellAbandonmentInterface {
  fields: Partial<WellGeothermalFieldsEdit>
  isLoading: boolean
  setValue: SetValue<WellGeothermalFieldsEdit>
  validationErrors: ValidationErrors
}

export default function WellAbandonmentEdit({
  fields,
  isLoading,
  validationErrors,
  setValue,
}: WellAbandonmentInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Abandonment
      </Heading>
      <FormField
        isSkeleton={isLoading}
        label='Well abandonment standard'
        labelId='wellAbandonmentStandard'
        validationMessages={validationErrors?.wellAbandonmentStandard}
      >
        <LookupField
          isSkeleton={isLoading}
          labelledBy='wellAbandonmentStandard'
          fieldId='wellAbandonmentStandard'
          value={`${fields.wellAbandonmentStandard ?? ''}`}
          setValue={({ value }) => setValue('wellAbandonmentStandard', value)}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Well abandonment details'
        htmlFor='wellAbandonmentDetails'
        validationMessages={validationErrors?.wellAbandonmentDetails}
      >
        <TextInput
          isSkeleton={isLoading}
          type='text'
          id='wellAbandonmentDetails'
          value={`${fields.wellAbandonmentDetails ?? ''}`}
          setValue={(value) => setValue('wellAbandonmentDetails', value)}
        />
      </FormField>
    </>
  )
}
